import React from 'react';
import PropTypes from 'prop-types';

interface HeadingProps extends React.HTMLAttributes<HTMLElement> {
    size?: 1 | 2 | 3 | 4 | 5 | 6;
    // Baseline arguments
    children?: React.ReactNode;
    className?: string;
}

/**
 * The classic header with a little fusion twist.
 * 
 * ## _
 * ### Arguments
 * @param {int} size - Any number from 1 to 6. Aligns with the traditional heading numbers, where 1 = highest emphasis, 6 = lowest.
 * @param {React.ReactNode} children - The contents inside the heading. This is usually just text.
 * @param {string} className - CSS classes to apply to the heading.
 */
class Heading extends React.Component<HeadingProps> {
    static propTypes = {
        size: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
        children: PropTypes.node,
        className: PropTypes.string,
    }

    static defaultProps = {
        size: 1,
        className: "",
    }

    render() {
        const { size, children, className, ...rest } = this.props;

        // Meant to sub-in for the h1 tag? Unused
        //const Tag = `h${size}` as keyof JSX.IntrinsicElements;

        let classes = `a-heading`
        classes += ` a-heading--heading-${size}`
        
        if (className) classes += ` ${className}`

        return (
            <h1 className={classes} {...rest}>
                {children}
            </h1>
        );
    }
}

export default Heading;